import React, { useState } from "react";

import "./stylesSportPerformanceTable.css";
import RebetLoader from "../../RebetLoader/RebetLoader";
import SportPerformanceTableRow from "./SportPerformanceTableRow/SportPerformanceTableRow";

function SportPerformanceTable() {
  const [isApiRunning, setIsApiRunning] = useState(false);
  const [activeTab, setActiveTab] = useState("Top Sport");

  const generateRandomData = (id) => ({
    id: id.toString(),
    name: "Footbal",
    avg_bets: (Math.random() * 100).toFixed(0),
    total_wagers: (Math.random() * 10000).toFixed(0),
    total_wagers_count: (Math.random() * 10000).toFixed(0),
    payout: (Math.random() * 10000).toFixed(0),
    profit_margins: (Math.random() * 10000).toFixed(0),
  });

  const repeatedData = Array.from({ length: 5 }, (_, index) =>
    generateRandomData(index + 1)
  );

  const [data, setData] = useState(repeatedData);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    const sortedData = [...data].sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === "asc" ? -1 : 1;
      }
      if (a[key] > b[key]) {
        return direction === "asc" ? 1 : -1;
      }
      return 0;
    });

    setData(sortedData);
  };

  return (
    <div className="dashboard-sport-performance-table-container">
      <div className="dashboard-sport-performance-table">
        <>
          <div className="head-controls">
            <div className="header-text-container">
              <p className="header-text">Sport performance metrics</p>
            </div>
          </div>
          <div className="table-container">
            {isApiRunning ? (
              <RebetLoader height={"100px"} width={"100px"} />
            ) : (
              <>
                <div className="sport-performance-tabs">
                  <div
                    className={`sport-performance-tab ${
                      activeTab === "Top Sport" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("Top Sport")}
                  >
                    Top Sport
                  </div>
                  <div
                    className={`sport-performance-tab ${
                      activeTab === "Top Leagues" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("Top Leagues")}
                  >
                    Top Leagues
                  </div>
                  <div
                    className={`sport-performance-tab ${
                      activeTab === "Top Games" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("Top Games")}
                  >
                    Top Games
                  </div>
                  <div
                    className={`sport-performance-tab ${
                      activeTab === "Top Markets" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("Top Markets")}
                  >
                    Top Markets
                  </div>
                </div>
                <SportPerformanceTableRow
                  is_header_row={true}
                  data={{}}
                  handleSort={handleSort}
                />

                {data &&
                  data.map((data, index) => (
                    <SportPerformanceTableRow
                      key={index}
                      is_header_row={false}
                      data={data}
                      handleSort={() => {}}
                    />
                  ))}
              </>
            )}
          </div>
        </>
      </div>
    </div>
  );
}

export default SportPerformanceTable;
